module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAfCAYAAACGVs+MAAAAWklEQVRYR2NkoAwIQLV/INcYRnI1QvUJQ+m35Joz6oDREBgNgdEQGA2B0RAYFCHAy8DAIElmbUZpdfx8UIQAmZ4HaxttD4yGwGgIjIbAaAiMhsCAhwCl1TEDAGapIC07YfDPAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/addImg.png
// module id = 114
// module chunks = 1